import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ltx/phase-i/consultations/earNoseThroat";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	earNoseThroat: {
		id: "form.ear_nose_throat",
		defaultMessage: "Fül-orr-gégészeti szakvizsgálat"
	},
	result: {
		id: "form.ear_nose_throat.result",
		defaultMessage: "Eltérés"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.result }] }]
};

export const node: LeafNode = {
	id: "earNoseThroat",
	value: {
		title: messages.earNoseThroat,
		validator,
		fieldset,
		isImportant: true
	}
};
